import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { useTranslation } from "react-i18next";

export const useFeedBackTableColumns = () => {
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "optionSelected",
      width: 250,
      headerName: `${t(messages.OPTION_SELECTED())}`,
    },
    {
      field: "message",
      width: 250,
      headerName: `${t(messages.MESSAGE())}`,
    },
    {
      field: "email",
      width: 250,
      headerName: `${t(messages.Email())}`,
    },

    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),
    {
      field: "feedBackId",
      width: 250,
      sortable: false,
      filterable: false,
    },
    {
      field: "id",
      width: 300,
      headerName: `${t(messages["id"]())}`,
      filterable: false,
    },
  ];

  return columns;
};
